/**
 * File utilities
 */

/**
 * Removes file extension from filename
 * @param {string} filename - File name
 * @returns {string} File name without extension
 */
export const removeFileExtension = (filename) => {
    if (!filename) return filename;
    return filename.replace(/\.(png|jpg|jpeg|gif|webp|svg|bmp|tiff|ico)$/i, '');
};
